"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NYE = NYE;
exports.MLK = MLK;
exports.PresidentsDay = PresidentsDay;
exports.GoodFriday = GoodFriday;
exports.MemorialDay = MemorialDay;
exports.IndependenceDay = IndependenceDay;
exports.LaborDay = LaborDay;
exports.ThanksgivingDay = ThanksgivingDay;
exports.ChristmasDay = ChristmasDay;
exports.IsHoliday = IsHoliday;
exports.TradingHalfDay = TradingHalfDay;
const date_1 = require("./date");
function DateForWeekday(year, month, day_from, day_to, day_of_week) {
    for (let day = day_from; day <= day_to; day++) {
        const date = new date_1.Date(year, month, day);
        if (date.dayOfWeek() === day_of_week) {
            return date;
        }
    }
    throw new Error("Can't find day of week");
}
function NYE(year) {
    return new date_1.Date(year, 1, 1);
}
// Martin Luther King, any Monday between Jan 15 to Jan 21.
function MLK(year) {
    return DateForWeekday(year, 1, 15, 21, date_1.DayOfWeek.MONDAY);
}
// Any Monday from Feb 15 to Feb 21."""
function PresidentsDay(year) {
    return DateForWeekday(year, 2, 15, 21, date_1.DayOfWeek.MONDAY);
}
/**
 * Returns the date for Good Friday on the given year.
 * {@link https://stackoverflow.com/questions/2510383/how-can-i-calculate-what-date-good-friday-falls-on-given-a-year}.
 */
function GoodFriday(year) {
    let g = Math.floor(year % 19);
    let c = Math.floor(year / 100);
    let h = (c - Math.floor(c / 4) - Math.floor((8 * c + 13) / 25) + 19 * g + 15) % 30;
    let i = (h - Math.floor(h / 28)
        * (1 - Math.floor(h / 28)
            * Math.floor(29 / (h + 1))
            * Math.floor((21 - g) / 11)));
    let day = i - ((year + Math.floor(year / 4) + i + 2 - c + Math.floor(c / 4)) % 7) + 28;
    let month = 3;
    if (day > 31) {
        month += 1;
        day -= 31;
    }
    return new date_1.Date(year, month, day).addDay(-2);
}
// Monday between May 25 and May 31
function MemorialDay(year) {
    return DateForWeekday(year, 5, 25, 31, date_1.DayOfWeek.MONDAY);
}
function IndependenceDay(year) {
    return new date_1.Date(year, 7, 4);
}
// Monday from Sept 1st to Sept 7th
function LaborDay(year) {
    return DateForWeekday(year, 9, 1, 7, date_1.DayOfWeek.MONDAY);
}
// Thursday from Nov 22 to Nov 28th
function ThanksgivingDay(year) {
    return DateForWeekday(year, 11, 22, 28, date_1.DayOfWeek.THURSDAY);
}
function ChristmasDay(year) {
    return new date_1.Date(year, 12, 25);
}
const ALL_HOLIDAYS = [
    NYE,
    MLK,
    PresidentsDay,
    GoodFriday,
    MemorialDay,
    IndependenceDay,
    LaborDay,
    ThanksgivingDay,
    ChristmasDay,
];
function IsHoliday(date) {
    for (let i = 0; i < ALL_HOLIDAYS.length; i++) {
        if (ALL_HOLIDAYS[i](date.year).eq(date)) {
            return true;
        }
    }
    return false;
}
// There are 3 trading half days
function TradingHalfDay(index, year) {
    if (index === 0) {
        // July 3rd
        return new date_1.Date(year, 7, 3);
    }
    if (index === 1) {
        // Day after Thanksgiving
        return ThanksgivingDay(year).increment();
    }
    if (index === 2) {
        // Day before Christmas
        return ChristmasDay(year).decrement();
    }
    throw new Error("Only 3 trading half days");
}
